import React, { FC } from 'react';
import './ImageView.css';
import { useMedia } from '@/Shared/Logic/Hooks/TechnicalHooks/useMedia';

interface ImageViewProps {
	src: string,
	alt?: string,
}

const ImageView: FC<ImageViewProps> = ({ src, alt = 'Image' }) => {

	const media = useMedia();

	return (<img
		ref={media.mediaRef}
		className="ImageView"
		data-testid="ImageView"
		src={src}
		alt={alt} />);
}

export default ImageView;
